var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 107 106",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.098 20.422-8.72-8.752-7.267 7.293 8.72 8.753zM14.534 48.138H0v9.724h14.534zM58.134 0h-9.689v14.1h9.69zm36.334 18.963-7.267-7.293-8.72 8.752 6.782 6.807zM78.481 85.578l8.72 8.752 6.783-6.807-8.72-8.752zm13.565-37.44v9.724h14.533v-9.724zM53.29 23.826c-15.987 0-29.067 13.128-29.067 29.174s13.08 29.174 29.067 29.174S82.357 69.046 82.357 53 69.277 23.826 53.29 23.826zM48.445 106h9.69V91.9h-9.69zM12.111 87.037l7.267 7.293 8.72-8.752-6.782-6.807z"
  })));
};

export default SvgSun;